/**
 * Emojis und Sonderzeichen (♡ ★ ♪ …) in Texten auf dem Artwork: mit den Schriften des Rechners
 * („system") oder mit unseren einheitlichen Schriften „Ohmy Emoji"/„Ohmy Symbols" („ohmy").
 *
 * STANDARD = "system", solange der Kunden-Editor im Shop (ohmy-ai) noch die Geräte-Emojis zeigt:
 * Der Kunde hat sein Motiv mit den Emojis seines Geräts gesehen, also drucken wir vorerst auch so —
 * und das geht nur im Browser. Solche Tasks werden deshalb nie auf dem Server gerendert und nie
 * automatisch importiert. Beim Rollout von ohmy-ai auf "ohmy" stellen — an BEIDEN Stellen:
 *   hier DEFAULT_EMOJI_FONT  und  firebase_aq/functions-upscaler/src/printFile.ts (DEFAULT_EMOJI_FONT)
 */
export const DEFAULT_EMOJI_FONT = "system";

// Zeichenvorrat der Server-Schriften (Kopie von functions-upscaler/src/emojiCoverage.json — bei
// neuen Schriften dort neu erzeugen und hier mitkopieren)
import coverage from "./fontCoverage.json";

const inRanges = (cp, ranges) => ranges.some(([a, b]) => cp >= a && cp <= b);

/**
 * Zeichen, die KEINE Server-Schrift setzen kann (z. B. kyrillisch, chinesisch): weder die gewählte
 * Textschrift noch Emoji- oder Symbol-Schrift. Der Browser nimmt dafür eine Schrift des Rechners —
 * solche Tasks werden immer lokal importiert. Unbekannte Schrift = nicht beurteilbar = keine Meldung.
 */
export const unsupportedChars = (text, font) => {
  const known = (font && coverage.fonts[font]) || null;
  if (!known) return [];
  const out = [];
  for (const ch of String(text || "")) {
    const cp = ch.codePointAt(0) || 0;
    if (cp <= 0x20 || cp === 0x200d || cp === 0xfe0f) continue;
    const byEmoji = inRanges(cp, coverage.ranges) && inRanges(cp, coverage.covered);
    if (!byEmoji && !inRanges(cp, known) && !inRanges(cp, coverage.symbols || []) && !out.includes(ch)) out.push(ch);
  }
  return out;
};

// = unicode-range der Webfonts „Ohmy Emoji" + „Ohmy Symbols" (src/assets/styles/app.scss)
const SPECIAL_GLYPHS = /[⃣←-∑∓∔∖-⏿①-➿⤀-⥿⬀-⯿〰〽㊗㊙\u{1F000}-\u{1FAFF}\u{E0020}-\u{E007F}]/u;

/** Enthält der Text Emojis oder Sonderzeichen, die eine unserer beiden Schriften übernähme? */
export const hasSpecialGlyphs = (text) => SPECIAL_GLYPHS.test(String(text || ""));

/** CSS-Schriftliste für einen Text auf dem Artwork */
export const textFontStack = (font, emojiFont) => {
  const base = font ? `"${font}"` : "sans-serif";
  // „Ohmy Emoji"/„Ohmy Symbols" zuerst: greifen per unicode-range nur für ihre Zeichen
  return emojiFont === "ohmy" ? `"Ohmy Emoji", "Ohmy Symbols", ${base}` : base;
};
